import type { OnInit, Signal } from '@angular/core';
import { Component, inject } from '@angular/core';
import { FormatStorageSizePipe } from '@hunting-nature/shared-ui/pipes/format-storage-size.pipe';
import { IonIcon, IonItem, IonLabel, IonList, IonListHeader, IonNote, IonProgressBar } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { addIcons } from 'ionicons';
import { ellipse } from 'ionicons/icons';

import { SettingsActions } from '../../../../../../shared/redux/settings/settings.actions';
import { SettingsSelectors } from '../../../../../../shared/redux/settings/settings.reducer';

import type { StorageInformation } from './storage-information';

@Component({
  selector: 'app-storage-information',
  standalone: true,
  templateUrl: './storage-information.component.html',
  styleUrl: './storage-information.component.scss',
  imports: [IonListHeader, TranslocoPipe, IonList, IonLabel, IonItem, IonNote, FormatStorageSizePipe, IonProgressBar, IonIcon],
})
export class StorageInformationComponent implements OnInit {
  // services
  private readonly store = inject(Store);

  // UI bindings
  protected readonly storageInformation$$: Signal<StorageInformation> = this.store.selectSignal(SettingsSelectors.getStorageInformation);

  constructor() {
    addIcons({ ellipse });
  }

  ngOnInit(): void {
    this.store.dispatch(SettingsActions.initStorageInformation());
  }
}
